export default __webpack_public_path__ + "static/media/Bloodseeker Blade.83ea87f1.jpg";